import React, { createContext, useState, useContext } from 'react';
import { Snackbar, Alert } from '@mui/material';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState({
        open: false,
        message: '',
        severity: 'info', // 'error', 'warning', 'info', 'success'
        action: null
    });

    const showNotification = (message, severity = 'info', action = null) => {
        setNotification({
            open: true,
            message,
            severity,
            action
        });
    };

    const showError = (message, action = null) => showNotification(message, 'error', action);
    const showWarning = (message, action = null) => showNotification(message, 'warning', action);
    const showSuccess = (message) => showNotification(message, 'success');
    const showInfo = (message) => showNotification(message, 'info');

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setNotification(prev => ({ ...prev, open: false }));
    };

    return (
        <NotificationContext.Provider value={{
            showNotification,
            showError,
            showWarning,
            showSuccess,
            showInfo
        }}>
            {children}
            <Snackbar
                open={notification.open}
                autoHideDuration={6000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleClose}
                    severity={notification.severity}
                    variant="filled"
                    sx={{ width: '100%', minWidth: 300 }}
                    action={notification.action}
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </NotificationContext.Provider>
    );
};
